import { FC } from "react";
import { useResourceRegister } from "@/utils/resourceRegister";

const EncryptionMappingsResourceRegister: FC = () => {
  useResourceRegister({ name: 'encryption/mappings' })
  
  return (
    null
  )
}

export default EncryptionMappingsResourceRegister;
